import monitoringPersonal from './mock/monitoringPersonal.json'
import monitoringTotal from './mock/monitoringTotal.json'
import monitoringTotalSigu from './mock/monitoringTotalSigu.json'
import area from './mock/area.json'
import inverters from './mock/inverters.json'
import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'

export function getMonitoringPersonal(userId, sido, sigu) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  let parameters = `userId=${userId !== undefined ? userId : ''}&sido=${
    sido !== undefined ? sido : ''
  }&sigu=${sigu !== undefined ? sigu : ''}`

  if (isUseAPI()) {
    return request({
      url: `/monitoring/site?${parameters}`,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(monitoringPersonal)
  })
}

export function getMonitoringSiteInverter(siteId) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: `/monitoring/site/${siteId}/inverter`,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(inverters)
  })
}

export function getMonitoringTotal(userId, type, customerType) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  let parameters = `userId=${
    userId !== undefined && userId !== '' ? userId : ''
  }&type=${type !== undefined && type !== '' ? type : 'sido'}`

  if (customerType !== undefined && customerType !== '') {
    parameters += `&customerType=${customerType}`
  }
  if (isUseAPI()) {
    return request({
      url: `/monitoring/total?${parameters}`,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(monitoringTotal)
  })
}

export function getMonitoringTotalTemp() {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(monitoringTotalSigu)
  })
}

export function getMonitoringYesterDay(siteId) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: `/monitoring/site/${siteId}/yesterday`,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(monitoringTotal)
  })
}

export function getMonitoringTotalY(userId) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: `/monitoring/site/yesterday?userId=` + userId,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(monitoringTotal)
  })
}

export function getArea() {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: `/monitoring/area`,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(area)
  })
}

export function getSearchSite(parameters) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  // let userId = 'parkka0114'
  if (isUseAPI()) {
    return request({
      url: `/monitoring/site/search?${parameters}`,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(monitoringPersonal)
  })
}
